import { Component, HostBinding, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { faHome, faUsers, faFileInvoice, faLightbulb, faShoppingCart, faCalendar, faCogs, faChevronLeft, faChevronRight, faImage, faClock, faCircle, faCircleQuestion, faClipboardList, faBug, faHeadset, faPencil, faComments, faAddressBook, faUserClock, faMoon, faSun, faHandshake, faDiagramProject, faClone } from '@fortawesome/free-solid-svg-icons';
import { UserRole } from '../user-role';
import { User } from '../user';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgIf } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbTooltip, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';
import { DarkModeService } from '@app-shared/services/dark-mode.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  imports: [NgbTooltip, FaIconComponent, NgIf, RouterLink, RouterLinkActive, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem]
})
export class NavbarComponent implements OnInit {

  // Properties
  @HostBinding('style.width') hostWidth = '70px';
  isOpen: boolean = false;
  userInitials: string = '##';
  public hasAccess: boolean = true;
  loginDetails: User;
  isDarkModeEnabled: boolean = false;

  // Font Awesome Properties
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faHome = faHome;
  faUsers = faUsers;
  faDiagramProject = faDiagramProject;
  faHandshake = faHandshake;
  faFileInvoice = faFileInvoice;
  faLightbulb = faLightbulb;
  faShoppingCart = faShoppingCart;
  faCalendar = faCalendar;
  faImage = faImage;
  faClock = faClock;
  faClipboardList = faClipboardList;
  faCircleQuestion = faCircleQuestion;
  faBug = faBug;
  faCogs = faCogs;
  faCircle = faCircle;
  faHeadset = faHeadset;
  faComments = faComments;
  faAddressBook = faAddressBook;
  faPencil = faPencil;
  faUserClock = faUserClock;
  faMoon = faMoon;
  faSun = faSun;
  faClone = faClone

  constructor(private authService: AuthService,
    private darkModeService: DarkModeService) {
    this.darkModeService.darkModeChanged$.subscribe((isDarkModeEnabled) => {
      this.isDarkModeEnabled = isDarkModeEnabled;
    });
  }

  async ngOnInit(): Promise<void> {
    this.userInitials = await this.getUserInitials();
    this.loginDetails = JSON.parse(localStorage.getItem('login'));

    let login = JSON.parse(localStorage.getItem("login"));
    if ((login.role == 'SUPER' || login.role == 'FRANCHISE_OWNER') && (!login.providesAccess || login.subscription.organizationStatus == "DELINQUENT" || login.subscription.organizationStatus == "INACTIVE" || !login.isWithCardOnFile)) {
      this.hasAccess = false;
    }
  }

  // Is Authorized
  isAuthorized(): boolean {
    return this.authService.isAuthorized(UserRole.FRANCHISEE);
  }

  // Toggle
  toggle(): void {
    if (!this.isOpen) {
      this.hostWidth = '220px';
    } else {
      this.hostWidth = '70px';
    }
    this.isOpen = !this.isOpen;
  }

  // Logout
  logout(): void {
    this.authService.logout();
  }

  /* ----- Helper Functions ----- */

  // Get User Initials
  private async getUserInitials(): Promise<string> {
    const user = await this.authService.getCurrentUser();
    return user.firstName.substring(0, 1) + user.lastName.substring(0, 1);
  }

  // Set Next Route
  setNextRoute(route: any) {
    sessionStorage.setItem("nextRoute", route)
  }

  // Toggle Dark Mode
  toggleDarkMode(): void {
    this.darkModeService.toggleDarkMode();
  }
}
